function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m410.453125 208.652344c-56.949219-.65625-102.601563-47.328125-102-104.277344.316406-43.867188 27.214844-83.152344 68-99.304688-14.238281-3.84375-28.972656-5.515624-43.710937-4.96875-78.65625.878907-141.714844 65.34375-140.855469 144-.859375 78.65625 62.199219 143.121094 140.855469 144 59.53125.273438 112.472656-37.8125 131.144531-94.34375-15.882813 10.28125-34.523438 15.480469-53.433594 14.894532zm0 0",
  fill: "#fce666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m375.886719 288.101562c-5.851563 0-11.691407.585938-17.425781 1.742188-4.324219-21.582031-18.304688-39.992188-37.929688-49.957031-19.628906-9.964844-42.742188-10.382813-62.71875-1.136719-18.078125-49.796875-73.101562-75.507812-122.898438-57.429688-49.796874 18.082032-75.507812 73.105469-57.429687 122.902344-43.621094 1.378906-78.078125 37.480469-77.4257812 81.121094.6562502 43.636719 36.1835942 78.6875 79.8281252 78.757812h296c48.597656 0 88-39.398437 88-88 0-48.601562-39.402344-88-88-88zm0 0",
  fill: "#a3d4f7"
});

var SvgCloudyNight = function SvgCloudyNight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "0 0 464 464.10166",
    width: "464pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloudyNight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloudy-night.00ca63bc.svg";
export { ForwardRef as ReactComponent };